/**
 * @generated SignedSource<<e79958898d6c707e7a8fc187a777e6c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type LinkedSecurityAlertLinkItem$data = {
  readonly number: number | null | undefined;
  readonly repository: {
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  } | null | undefined;
  readonly status: CodeScanningSecurityAlertStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedSecurityAlertIcon">;
  readonly " $fragmentType": "LinkedSecurityAlertLinkItem";
};
export type LinkedSecurityAlertLinkItem$key = {
  readonly " $data"?: LinkedSecurityAlertLinkItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedSecurityAlertLinkItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedSecurityAlertLinkItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedSecurityAlertIcon"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CodeScanningSecurityAlert",
  "abstractKey": null
};

(node as any).hash = "47a04292b0f5066e09e592a1318097b8";

export default node;
